module.exports = __webpack_public_path__ + "static/img/intro-thumb-bg.a7a87bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newImg/intro-thumb-bg.png
// module id = gcA+
// module chunks = 0